import React, { useState, useEffect } from 'react';
import { Sparkles } from 'lucide-react';
import { useAuth } from '../../../contexts/AuthContext';
import { supabase } from '../../../lib/supabase';

const WelcomeHero = () => {
  const { user } = useAuth();
  const [displayName, setDisplayName] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDisplayName = async () => {
      if (!user?.id) {
        setLoading(false);
        return;
      }

      try {
        const { data, error } = await supabase?.from('user_profiles')?.select('display_name')?.eq('user_id', user?.id)?.single();

        if (error && error?.code !== 'PGRST116') {
          console.error('Error fetching display name:', error);
        }

        setDisplayName(data?.display_name || 'User');
      } catch (error) {
        console.error('Error fetching display name:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchDisplayName();
  }, [user?.id]);

  const getGreeting = () => {
    const hour = new Date()?.getHours();
    if (hour < 12) return 'Good morning';
    if (hour < 18) return 'Good afternoon';
    return 'Good evening';
  };

  return (
    <div className="bg-gradient-to-r from-teal-500 to-cyan-600 rounded-2xl p-8 text-white shadow-lg">
      <div className="flex items-center gap-3 mb-4">
        <Sparkles className="w-8 h-8" />
        <h1 className="text-3xl font-bold">
          {getGreeting()}, {loading ? '...' : displayName}!
        </h1>
      </div>
      <p className="text-teal-50 text-lg">
        Welcome back to your giving dashboard. Your generosity is making a real difference.
      </p>
    </div>
  );
};

export default WelcomeHero;